import React from "react";
import { Box, Button } from "@mui/material";

const ButtonSegment = ({ position = "middle", label, sx = {}, ...props }) => (
  <Button
    sx={{
      borderRadius: position === "start" ? "100px 0 0 100px" : position === "end" ? "0 100px 100px 0" : 0,
      ...sx
    }}
    {...props}
  >
    {label}
  </Button>
);

export default ButtonSegment;
